/**
 * 格式化时间
 * @param { string } timeStr: 时间为“YYYY-MM-DD hh:mm:ss”格式的字符串
 */
export function formatTime(timeStr) {
    var year = timeStr.slice(0, 4);
    var month = timeStr.slice(5, 10);
    var time = timeStr.slice(11, 16);
    var newsTime = new Date(timeStr);
    var today = new Date();
    // 判断是否是今天
    if (newsTime.toDateString() === today.toDateString()) {
        return "\u4ECA\u5929 " + time;
    }
    else if (Number(year) === today.getFullYear()) {
        return month + " " + time;
    }
    else {
        return year + " " + month + " " + time;
    }
}
/**
 * 格式化日期
 * @param { string } timeStr: 时间为“YYYY-MM-DD hh:mm:ss”格式的字符串
 */
export function formatDate(timeStr) {
    var date = timeStr.split(' ')[0];
    var dateArr = date.split('-');
    return dateArr[0] + "\u5E74" + dateArr[1] + "\u6708" + dateArr[2] + "\u65E5";
}
/**
 * a标签的rel属性
 * TODO: 暂时不使用
 */
export var relText = 'nofollow me noopener noreferrer';
/**
 * 合并className
 * @param { Array } argu: 传入的参数
 */
export function classNames() {
    var argu = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        argu[_i] = arguments[_i];
    }
    return argu.join(' ');
}
/**
 * styleName
 * @param { string } classname: 样式名称
 */
export function styleName(classname) {
    return "news-stream-" + classname;
}
